import { render, staticRenderFns } from "./FollowUpAddPopover.vue?vue&type=template&id=ca6239ba&scoped=true&"
import script from "./FollowUpAddPopover.vue?vue&type=script&lang=ts&"
export * from "./FollowUpAddPopover.vue?vue&type=script&lang=ts&"
import style0 from "./FollowUpAddPopover.vue?vue&type=style&index=0&id=ca6239ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6239ba",
  null
  
)

/* custom blocks */
import block0 from "./FollowUpAddPopover.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports